module.exports = __webpack_public_path__ + "static/media/apoLogo.3e4596e4.png";